import PageWrapper from "../../components/UI/PageWrapper";
import ArtistMappingForm from "../../components/Admin/ArtistMappingForm";

const ArtistMappingPage = () => (
  <PageWrapper>
    <div className="flex justify-center">
      <ArtistMappingForm />
    </div>
  </PageWrapper>
);

export default ArtistMappingPage;
